<template>
	<div>

		<section id="page-title" class="page-title-parallax page-title-dark" style="background: url('/static/images/teatro-colombo.png') center center no-repeat; background-size: cover; box-shadow:inset 0 0 0 2000px rgba(0,0,0,0.5); padding: 75px 0;" data-bottom-top="background-position:0px 300px;" data-top-bottom="background-position:0px -300px;">

			<div class="container clearfix">
				<h1>O Projeto</h1>
				<!-- <span>Ficha de Companhia</span> -->
				<!-- <ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="#">Home</a></li>
					<li class="breadcrumb-item"><a href="#">Pages</a></li>
					<li class="breadcrumb-item active" aria-current="page">Jobs</li>
				</ol> -->
			</div>

		</section><!-- #page-title end -->

		<!-- Content
		============================================= -->
		<section id="content">

			<div class="content-wrap">

				<div class="container clearfix">

					<!-- <div class="col_three_fifth nobottommargin"> -->
					<div class="col-12">

						<p>
							A base de dados Teatro Musicado em São Paulo (1914-1934) começou a ser construída como
							parte de uma <a href="http://www.teses.usp.br/teses/disponiveis/8/8138/tde-07122012-104254/publico/2012_VirginiaDeAlmeidaBessa_VCorr.pdf">pesquisa de doutorado</a> realizada entre 2008 e 2012 no Departamento de
							História Universidade de São Paulo, em cotutela com a Universidade Paris Nanterre. Com base
							em informações recolhidas na imprensa paulistana, foram arrolados todos os espetáculos
							teatrais encenados diariamente na cidade entre 1914 e 1934. Esse período corresponde à
							“fase áurea” do teatro na capital paulista, que vai da eclosão da Primeira Guerra Mundial
							(quando a interrupção do tráfego marítimo impediu a vinda ao Brasil de companhias teatrais
							estrangeiras, estimulando a produção teatral local) a meados dos anos 1930 (quando o cinema
							falado ultrapassou o teatro como principal entretenimento coletivo da cidade). Uma <a href="http://www.memoriadamusica.com.br/teatromusicado/">primeira versão</a> base de dados traz uma listagem filtrável das informações reunidas nessa primeira fase.
							<br><br>
							Embora tenham sido arrolados todos os espetáculos encenados na cidade, incluindo o teatro
							declamado, a ênfase da pesquisa recaiu sobre os gêneros musicados, não só por serem
							numericamente mais expressivos, mas também por serem menos conhecidos pela
							historiografia. Ao contrário do teatro musicado carioca, que foi objeto de trabalhos
							acadêmicos e jornalísticos, o teatro de burletas, operetas e revistas produzido e consumido em
							São Paulo nunca havia sido pesquisado a fundo. Levantar esses espetáculos e quantificá-los foi
							o primeiro passo para compreender o processo de formação de uma cultura de massa em São
							Paulo, bem como avaliar sua importância na difusão da música popular na cidade. Além disso,
							a inclusão da ópera entre os espetáculos arrolados revelou que o gênero era mais popular do
							que se imagina, e em certos aspectos muito próximo do teatro musicado.
							<br><br>
							A partir de 2016, como parte de uma pesquisa de pós-doutorado realizada no Instituto de
							Estudos Brasileiros da Universidade de São Paulo, teve início uma segunda fase da construção
							da base de dados. Usando como fonte a imprensa nacional e internacional, foram coletadas
							informações sobre as companhias de teatro musicado que se apresentaram na cidade
							(nacionalidade, membros componentes, trajetória), as peças encenadas (recepção pela crítica,
							idioma em que foram representadas) e os teatros da cidade (localização, data de fundação,
							proprietário, lotação etc.). Essas informações foram reunidas em fichas (de companhias, de
							pessoas, de teatros, de peças), que podem ser acessadas por meio de dois tipos de busca.
							<br><br>
						</p>

						<div class="fancy-title title-bottom-border">
							<h3>Como Pesquisar</h3>
						</div>

						<p>
							No formulário Pesquisar Espetáculos, pode-se buscar todos os espetáculos teatrais encenados na cidade entre 1914 e 1934. Os resultados podem ser filtrados por Teatro, Companhia,
							Nacionalidade da Companhia, Título da peça, Gênero, Nacionalidade da peça, Idioma da
							representação, Tipo de espetáculo, Autor da peça, Tradutor, Adaptador, Autor da música,
							Arranjador da Música, Data. Esses filtros também podem ser cruzados. Para saber, por
							exemplo, quais peças francesas foram representadas em português na cidade, basta selecionar
							essas informações nos campos “Nacionalidade da peça” e “Idioma de representação”. Antes
							de clicar no botão “Pesquisar”, o consulente deve escolher que tipo de resultado espera:
							completo (listagem de espetáculos, organizados por dia de representação), por companhia
							(listagem dos resultados agrupados por companhia) ou por peça (listagem dos resultados
							agrupados por peça). Seja qual for o tipo de resultado escolhido, ele trará links que
							direcionarão o consulente às fichas de companhias, teatros, pessoas, peças.
							<br><br>
							Além dos filtros, o consulente pode usar o campo de pesquisa livre, buscando todos os
							espetáculos que contenham determinada(s) palavra(s) no título da peça ou no nome da
							companhia.
							<br><br>
							No formulário Pesquisar Pessoas, pode-se buscar os agentes (autores de texto, autores de
							música, tradutores, atores/atrizes, diretores, ensaiadores, regentes de orquestra, figurinistas,
							cenógrafos, pontos etc.) que participaram da concepção ou da performance dos espetáculos
							arrolados. A busca pode ser por nome, ou então por filtros (Nacionalidade, Sexo). É possível
							também restringir as atividades da(s) pessoa(s) buscada(s). Por exemplo, para buscar as atrizes
							italianas que atuaram em São Paulo, basta selecionar os campo nacionalidade (italiana) e sexo
							(feminino), e depois restringir a atividade (ator/atriz). Nos resultados aparecerão uma lista de
							nomes no formato de links que, quando clicados, direcionarão o consulente à ficha daquela
							pessoa.
						</p>
						

					</div>

					<!-- <div class="col_two_fifth nobottommargin col_last">

						<div id="job-apply" class="heading-block highlight-me">
							<h2>Fotos</h2>
							<span>And we'll get back to you within 48 hours.</span>
						</div>

						<div>
							<img src="https://storage.googleapis.com/templates-html/companhia-arruda.png">
						</div>

					</div> -->

				</div>

			</div>

		</section>

	</div>
</template>



<script>

export default {
  name: 'About',
}

</script>


<style scoped>
.heading-block:after {
	margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue